import type { ConceptDef } from '../types';

export const endingSound: ConceptDef = {
  kind: 'tileMatch',
  id: 'ending-sound',
  label: 'Ending Sound',
  category: 'Literacy',
  description: 'Hear an ending letter; tap a word that ends with it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Which ends with G?', answer: '🐶 dog' },
      { say: 'Which ends with N?', answer: '🌞 sun' },
      { say: 'Which ends with T?', answer: '🐱 cat' },
      { say: 'Which ends with R?', answer: '⭐ star' },
      { say: 'Which ends with K?', answer: '📕 book' },
    ],
  },
};
